<template>
  <p class="text--small">
    <template v-if="genericSigners.length > 0">
      <i18n-t :keypath="`${TRANSLATION_KEY_PREFIX}.base`" scope="global">
        <span class="text--small">
          <span v-t="{
            path: `${TRANSLATION_KEY_PREFIX}.${isMultiEnvelope? 'countMultipleEnvelopes' : 'countSingleEnvelope'}`,
            plural: genericSigners.length,
            args: { count: genericSigners.length },
          }"/>
        </span>
        <span class="text--small text--bold">
          {{ formattedGenericSignersList }}
        </span>
      </i18n-t>
    </template>
    <template v-else>
      {{ $t(`${TRANSLATION_KEY_PREFIX}.noSigners`) }}
    </template>
  </p>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { ENVELOPE_TYPES } from '@/project/signing-checklist/constants'

const TRANSLATION_KEY_PREFIX = 'project.signing-checklist.add.step2.SigningChecklistTemplateSignersDetails'

type DataType = {
  ENVELOPE_TYPES: typeof ENVELOPE_TYPES
  TRANSLATION_KEY_PREFIX: typeof TRANSLATION_KEY_PREFIX,
}

export default defineComponent({
  name: 'SigningChecklistTemplateSignersDetails',
  props: {
    genericSigners: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
    isMultiEnvelope: {
      type: Boolean,
      default: false,
    },
  },
  data (): DataType {
    return {
      ENVELOPE_TYPES,
      TRANSLATION_KEY_PREFIX,
    }
  },
  computed: {
    formattedGenericSignersList (): string {
      if (this.genericSigners.length === 1) {
        return this.genericSigners[0]
      }
      const firsts = this.genericSigners.slice(0, this.genericSigners.length - 1)
      const last = this.genericSigners[this.genericSigners.length - 1]
      return `${firsts.join(', ')} ${this.$t('common.and')} ${last}`
    },
  },
})
</script>
